import { useCallback, useState } from 'react';
import constate from 'constate';
// import { useCanAccessUrlMutation } from 'query/authInfo-BC';
import { AuthInfoMapKey } from './constants/auth';
// import { useLoginAgentIdUsingPOSTMutation } from 'query/ad-common-login-controller';
// import { url } from '@i18n/uc';
// import axios from 'common/bcRequest';
// import { useDspAuthContext } from './dspAuth';

type AuthInfoType = Partial<Record<AuthInfoMapKey, boolean>>;

function CommonStore() {
    // const accountId = url.getAccountId();
    // const agentInfoMutate = useLoginAgentIdUsingPOSTMutation();
    // const { authInfo: dspAuthInfo } = useDspAuthContext();
    /**
     * 余额撞线弹窗
     */
    const [isBalanceDrawerShow, setIsBalanceDrawerShow] = useState(false);
    // const [defaultBalanceDrawerType, setDefaultBalanceDrawerType] = useState<TabsType>(TabsType.LowBalance);

    /**
     * 打开余额撞线弹窗默认tab
     */
    const openBalanceDrawerShowByDefault = useCallback(() => {
        setIsBalanceDrawerShow(true);
        // setDefaultBalanceDrawerType(TabsType.LowBalance);
    }, []);

    const closeBalanceDrawerShowByDefault = useCallback(() => {
        setIsBalanceDrawerShow(false);
        // setDefaultBalanceDrawerType(TabsType.LowBalance);
    }, []);
    /**
     * BC 权限
     */
    const [authInfo, setAuthInfo] = useState<AuthInfoType>({});
    /**
     * 校验函数
     */
    const validator = useCallback((targetUrl: string | string[], data?: string[]) => {
        const newTargetUrl = typeof targetUrl === 'string' ? [targetUrl] : targetUrl;
        if (data) {
            return newTargetUrl.reduce((sum, cur) => {
                return sum && data.includes(cur);
            }, true);
        }
        return false;
    }, []);
    /**
     * 获取权限
     */
    // const getAuthInfo = useCallback(async () => {
    //     const agentInfo = await agentInfoMutate.mutateAsync({ accountId: Number(accountId) });
    //     /**
    //      * 注入agentId
    //      */
    //     axios.interceptors.request.use((config) => {
    //         if (agentInfo.data) {
    //             config.headers.agentId = agentInfo.data;
    //         }
    //         return config;
    //     });
    //     const canAccessData = await canAccessUrlMutation.mutateAsync();
    //     // 计算逻辑
    //     const newAuthInfo: AuthInfoType = {};
    //     Object.keys(AuthInfoMap).forEach((v) => {
    //         // @ts-expect-error
    //         newAuthInfo[v] = validator(AuthInfoMap[v], canAccessData?.data);
    //     });
    //     setAuthInfo(newAuthInfo);
    // }, [accountId, agentInfoMutate, canAccessUrlMutation, validator]);

    // useEffect(() => {
    //     if (dspAuthInfo.hasBalanceEarlyWarning) {
    //         getAuthInfo();
    //     }
    // }, []);

    return {
        isBalanceDrawerShow,
        setIsBalanceDrawerShow,
        // defaultBalanceDrawerType,
        // setDefaultBalanceDrawerType,
        openBalanceDrawerShowByDefault,
        closeBalanceDrawerShowByDefault,
        /**
         * BC权限相关
         */
        authInfo,
        setAuthInfo,
        validator,
        // getAuthInfo,
    };
}

const [CommonStoreProvider, useCommonStoreContext] = constate(CommonStore);

export { CommonStoreProvider, useCommonStoreContext };
